import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PartnerService } from 'src/app/services/partner.service';

@Component({
  standalone: false,
  selector: 'app-corporate-deals-detail',
  templateUrl: './corporate-deals-detail.component.html',
})
export class CorporateDealsDetailComponent implements OnInit {
  id = '';
  isEditMode = false;
  validationTriggered = false;
  item: any = null;
  form: any = {};

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private partnerService: PartnerService,
    private toaster: ToastrService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id') ?? '';
    this.load();
  }

  load(): void {
    this.partnerService.get(this.id).subscribe({
      next: (result) => {
        this.item = result?.data ?? null;
        this.resetForm();
        this.isEditMode = false;
        this.validationTriggered = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.toaster.error('Corporate deal not found.');
        this.router.navigate(['/ecomm/corporate-deals']);
      },
    });
  }

  resetForm(): void {
    this.form = {
      partner_id: this.item.partner_id,
      corporate_id: this.item.corporate_id ?? '',
      name: this.item.name,
      countdown_minutes: this.item.countdown_minutes,
      status: this.item.status,
    };
  }

  startEdit(): void {
    this.resetForm();
    this.isEditMode = true;
    this.validationTriggered = false;
  }

  cancelEdit(): void {
    this.resetForm();
    this.isEditMode = false;
    this.validationTriggered = false;
  }

  save(): void {
    this.validationTriggered = true;
    if (!this.form.partner_id || !this.form.name || this.form.countdown_minutes === '' || this.form.countdown_minutes === null) {
      this.toaster.error('Please fill in all required fields.');
      return;
    }

    const payload = {
      partner_id: this.form.partner_id,
      corporate_id: this.form.corporate_id === '' ? null : this.form.corporate_id,
      name: this.form.name,
      countdown_minutes: Number(this.form.countdown_minutes),
      status: Number(this.form.status),
    };

    this.partnerService.update(this.id, payload).subscribe({
      next: (result) => {
        this.item = result.data;
        this.isEditMode = false;
        this.validationTriggered = false;
        this.toaster.success('Corporate deal updated.');
        this.cdr.detectChanges();
      },
      error: (error) => {
        this.toaster.error(error?.error?.message || 'Failed to update corporate deal.');
      },
    });
  }

  statusLabel(status: number): string {
    return status === 1 ? 'Active' : status === 2 ? 'Inactive' : String(status ?? '-');
  }

  onCountdownMinutesInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const digits = input.value.replace(/\D/g, '');
    this.form.countdown_minutes = digits;
    if (input.value !== digits) {
      input.value = digits;
    }
  }
}
